import * as React from 'react'
import { AppSidebar } from '@/components/sidebar/app-sidebar'
import {
  SidebarInset,
  SidebarProvider,
  ToggleSidebar,
} from '@/components/ui/sidebar'
import {
  BreadcrumbNav,
  type BreadcrumbItem,
} from '@/components/fragments/breadcrumb-nav'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
interface DashboardLayoutProps {
  pageTitle?: string | React.ReactNode
  breadcrumb?: Array<BreadcrumbItem>
  children: React.ReactNode
  className?: string
  innerClassName?: string
  onClick?: () => void
  onClickText?: string
  icon?: React.ReactNode
}

export default function DashboardLayout({
  pageTitle,
  breadcrumb,
  onClick,
  onClickText,
  icon,
  children,
  className,
  innerClassName,
}: DashboardLayoutProps) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className='bg-[#f5f5f5] h-screen md:p-5 overflow-y-auto hidden_scroll'>
        <section
          className={cn('p-4 flex items-center justify-between', className)}
        >
          <div>
            {pageTitle ? <h1 className='SFPro text-2xl'>{pageTitle}</h1> : ''}
            <BreadcrumbNav items={breadcrumb || []} className='mt-2' />
          </div>

          <div>
            {onClickText && (
              <Button variant='outline' onClick={onClick}>
                {icon}
                <span className='text-sm ml-2'>{onClickText}</span>
              </Button>
            )}
          </div>

          <div className=' items-center gap-1.5 cursor-pointer hidden lg:fle'>
            <img
              src='https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/avatars/91/914ba47874e675167658078508781e39b3984f5c_full.jpg'
              alt='avatar'
              className='w-[32px] h-[32px] p-1 rounded-full border-1 border-[#6366F1]'
            />
            <ChevronDown className='size-4 text-[#868787]' />
          </div>
          <ToggleSidebar className='md:hidden' />
        </section>
        <section className={cn('p-4', innerClassName)}>{children}</section>
      </SidebarInset>
    </SidebarProvider>
  )
}
